/*
 * lp-disclosure — shared accordion behaviour for the LP disclosure sections:
 * "About Zoe & ZOEVA" (lp-founder), "Trust & security" (lp-trust) and
 * "Product info & real reviews" (lp-about). (The "Explore the rest of the range"
 * disclosure keeps its own heading-crossfade in landing-page.js / setupRange.)
 *
 * Each toggle is the shared snippet's <button data-lp-about-toggle aria-controls>;
 * we flip aria-expanded and toggle .is-open on the panel it controls (the
 * grid-rows 0fr→1fr animation lives in each section's CSS). If the panel holds a
 * <video data-lp-disc-video> (founder portrait clip), it plays while open and
 * pauses while closed.
 *
 * Idempotent: each toggle is wired once (data-lp-disc-wired guard), so loading
 * this asset from multiple disclosure sections is safe.
 */
(function () {
  function wire(toggle) {
    if (toggle.dataset.lpDiscWired) return;
    toggle.dataset.lpDiscWired = '1';
    var panel = document.getElementById(toggle.getAttribute('aria-controls') || '');
    if (!panel) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      panel.classList.toggle('is-open', !open);
      var video = panel.querySelector('video[data-lp-disc-video]');
      if (video) {
        if (!open) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      }
    });
  }
  function init() {
    document.querySelectorAll('[data-lp-about-toggle]').forEach(wire);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
